__turbopack_context__.v({
  "isTabActive": "tabList-module-scss-module__YoQWPW__isTabActive",
  "slider": "tabList-module-scss-module__YoQWPW__slider",
  "tabItem": "tabList-module-scss-module__YoQWPW__tabItem",
  "tabItemIcon": "tabList-module-scss-module__YoQWPW__tabItemIcon",
  "tabLabel": "tabList-module-scss-module__YoQWPW__tabLabel",
  "tabsList": "tabList-module-scss-module__YoQWPW__tabsList",
  "tabsWrp": "tabList-module-scss-module__YoQWPW__tabsWrp",
});
